export default __webpack_public_path__ + "563c853a7d13346ee52d0c10af7d2f88.svg";